module.exports = Object.freeze({
  CUSTO_SHOPPER_MER_COOKIE: 'custoShopperMerCookie',
  LOGGED_OUT_INFO_COOKIE: 'loggedOutInfoCookie'
});